import type { FC, ForwardRefExoticComponent, HTMLAttributes, PropsWithoutRef, ReactNode, RefAttributes } from "react"

import { EBadgeVariant } from "@/3514/components"

import type { IModuleExcerptModel } from "../types"

type TJourneyAchievementModelToRender = {
    icon: ReactNode
    label: string
    badgeVariant: EBadgeVariant
    badgeAccentText: string
    badgeOptionalText?: string
}

enum EParticipantHeaderComponentLayout {
    Page = "page",
    /**
     * @deprecated analytics is on hold for now, potentially will be done with other elements
     */
    AnalyticsModal = "AnalyticsModal"
}

type TParticipantHeaderComponentHelperProps = {
    layout: EParticipantHeaderComponentLayout
    children: ReactNode
} & Partial<HTMLAttributes<HTMLElement>>

type TParticipantHeaderComponentRenderProps<TCustomProps extends Object = {}> = {
    renderConfig: {
        layout?: EParticipantHeaderComponentLayout
        titleWrapper?: FC<TParticipantHeaderComponentHelperProps>
        contentWrapper?:
            | ForwardRefExoticComponent<
                  PropsWithoutRef<TParticipantHeaderComponentHelperProps> & RefAttributes<HTMLDivElement>
              >
            | FC<{ children: ReactNode }>
        componentWrapper?: FC<TParticipantHeaderComponentHelperProps>
    } & TCustomProps
}

enum EParticipantHeaderComponentName {
    NextSession = "NextSession",
    ModulesExcerpts = "ModulesExcerpts",
    JourneyAchievements = "JourneyAchievements"
}

enum EParticipantHeaderVariant {
    Dashboard = "Dashboard",
    DashboardWelcomePage = "DashboardWelcomePage",
    Chapter = "Chapter"
}

type TModuleExcerptModelToRender = IModuleExcerptModel & { isStub?: boolean }

export { EParticipantHeaderComponentName, EParticipantHeaderComponentLayout, EParticipantHeaderVariant }
export type {
    TJourneyAchievementModelToRender,
    TModuleExcerptModelToRender,
    TParticipantHeaderComponentRenderProps,
    TParticipantHeaderComponentHelperProps
}
